import { render } from "./pb-pagehomeprojects.vue?vue&type=template&id=1e7d87aa"
import script from "./pb-pagehomeprojects.vue?vue&type=script&lang=js"
export * from "./pb-pagehomeprojects.vue?vue&type=script&lang=js"

import "./pb-pagehomeprojects.vue?vue&type=style&index=0&id=1e7d87aa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__